import { c as _c } from "react/compiler-runtime";
import { useApplyLinkForDirectLink } from '@cc-shopping/utils/directToApplication';
import type { BoxProps } from '@mui/material';
import { ApplyNowButton } from 'src/features/product-card/ApplyNowButton';
import { type CompareAnalytics, useCreditCardCompareOfferContext } from '../../OfferContext';
import { ProductCardApplyNowContainer } from './ApplyNow.container';
type ProductCardApplyNowProps = {
  analyticsProps?: Partial<CompareAnalytics>;
  containerProps?: BoxProps;
  needsFixedHeight?: boolean;
};
export function ProductCardApplyNow(t0) {
  const $ = _c(26);
  const {
    analyticsProps,
    containerProps,
    needsFixedHeight: t1
  } = t0;
  const needsFixedHeight = t1 === undefined ? false : t1;
  const {
    analytics,
    offer
  } = useCreditCardCompareOfferContext();
  const {
    applyLink,
    id,
    phoneNumber,
    institution: t2,
    monetizable,
    reviewLink,
    termsAndFeesLink,
    status,
    versionId,
    name
  } = offer;
  const {
    name: institutionName
  } = t2;
  let t3;
  if ($[0] !== status) {
    t3 = status.toLowerCase();
    $[0] = status;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const isActive = t3 === "active";
  let t4;
  if ($[2] !== monetizable) {
    t4 = monetizable.includes("yes");
    $[2] = monetizable;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const isMonetizing = t4;
  const t5 = applyLink ?? "";
  let t6;
  if ($[4] !== id || $[5] !== isMonetizing || $[6] !== t5) {
    t6 = {
      offerId: id,
      originalApplyLink: t5,
      isMonetizing
    };
    $[4] = id;
    $[5] = isMonetizing;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const modifiedApplyLink = useApplyLinkForDirectLink(t6);
  let t7;
  if ($[8] !== analytics || $[9] !== analyticsProps) {
    t7 = {
      ...analytics,
      ...analyticsProps,
      linkType: "APPLY_NOW_BUTTON"
    };
    $[8] = analytics;
    $[9] = analyticsProps;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== institutionName || $[12] !== isActive || $[13] !== isMonetizing || $[14] !== modifiedApplyLink || $[15] !== name || $[16] !== phoneNumber || $[17] !== reviewLink || $[18] !== t7 || $[19] !== termsAndFeesLink || $[20] !== versionId) {
    t8 = <ApplyNowButton analytics={t7} id="product-card-apply-now" isActive={isActive} isMonetizing={isMonetizing} applyLink={modifiedApplyLink} reviewLink={reviewLink} applyPhoneNumber={phoneNumber} institutionName={institutionName} ctaType="APPLY_NOW_BUTTON" versionId={versionId} linkSx={_temp} termsFeesRedirectLink={termsAndFeesLink} name={name} />;
    $[11] = institutionName;
    $[12] = isActive;
    $[13] = isMonetizing;
    $[14] = modifiedApplyLink;
    $[15] = name;
    $[16] = phoneNumber;
    $[17] = reviewLink;
    $[18] = t7;
    $[19] = termsAndFeesLink;
    $[20] = versionId;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== containerProps || $[23] !== needsFixedHeight || $[24] !== t8) {
    t9 = <ProductCardApplyNowContainer containerProps={containerProps} needsFixedHeight={needsFixedHeight}>{t8}</ProductCardApplyNowContainer>;
    $[22] = containerProps;
    $[23] = needsFixedHeight;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
}
function _temp(t0) {
  const {
    palette: t1
  } = t0;
  const {
    primary
  } = t1;
  return {
    minWidth: "100px",
    "&:hover": {
      backgroundColor: primary.dark
    }
  };
}